import { Heading } from 'blaze-ui/Heading/Heading'
import { useId } from '@react-aria/utils'
import { FormikPostDaysRadioGroup } from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/PostDaysRadioGroup'
import Styles from './EditScheduleModal.module.scss'
import { WrapperCard } from 'components/AddCampaignModal/WrapperCard'

export const DaysToPost = () => {
  const id = useId()

  return (
    <WrapperCard>
      <Heading level={4} id={id}>
        Days to post (per channel)
      </Heading>
      <FormikPostDaysRadioGroup name="week_days" aria-labelledby={id} className={Styles.radioGroup} />
    </WrapperCard>
  )
}
